import { resourcesCopy } from '@/copy/resources'
import { Card } from '@/ui/Card/Card'
import { TextareaField } from '@/ui/Field/Field'
import { Stack } from '@/ui/layout/Stack'
import { Text } from '@/ui/layout/Text'
import { Markdown } from '@/ui/Message/Markdown'
import { type FieldProps, type Fields, fieldStr } from './shared'

// eslint-disable-next-line react-refresh/only-export-components -- local component; the descriptor below is this file's only export
function NoteFields({ fields, set }: FieldProps) {
  return (
    <Stack gap="space-8">
      <TextareaField
        id="res-content"
        label={resourcesCopy.forms.note.content}
        value={fields.content ?? ''}
        onValue={(v) => set('content', v)}
        textareaProps={{ rows: 8 }}
      />
      <section aria-label={resourcesCopy.form.preview}>
        <Card variant="inset">
          {fields.content ? (
            <Markdown source={fields.content} />
          ) : (
            <Text tone="text-mute">{resourcesCopy.form.previewEmpty}</Text>
          )}
        </Card>
      </section>
    </Stack>
  )
}

export const noteForm = {
  Fields: NoteFields,
  toBody: (f: Fields) => ({ content: f.content ?? '' }),
  fromResource: (d: unknown) => ({ content: fieldStr(d, 'content') }),
}
